import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { useGetPurchasedFoodAndDrinkItemRecords } from '@shared/api/hooks/purchased-goods/food-and-drink';
import PurchasedFoodAndDrinkItemPurchasesTable from '../components/item/purchased-food-and-drink-item-purchases-table';
import { usePurchasedFoodAndDrinkItem } from '../purchased-food-and-drink-item-context';

export default function PurchasedFoodAndDrinkItemPurchasesPage() {
  const { item } = usePurchasedFoodAndDrinkItem();
  const { recordsParams } = useItemScope();

  const { page, perPage, sort } = useDataTableQueryState();

  const {
    data,
    status,
    isLoading,
    isFetching,
    isPreviousData,
    isFetchedAfterMount,
  } = useGetPurchasedFoodAndDrinkItemRecords({
    activityUuid: item.uuid,
    params: {
      page_size: perPage,
      page,
      ...recordsParams,
      sort: formatMultipleSortingForEndpoint(sort! || []),
    },
  });

  return (
    <Page name={`${item.purchasedGood.name} purchases`} page="subpage">
      <PurchasedFoodAndDrinkItemPurchasesTable
        data={data!}
        status={status}
        isLoading={isLoading}
        isFetching={isFetching}
        isPreviousData={isPreviousData}
        isFetchedAfterMount={isFetchedAfterMount}
      />
    </Page>
  );
}
